// extracted by mini-css-extract-plugin
export default {"modifiers":"MxqkPA4E","modifierRow":"rK3JOdPQ","modifierLabel":"AGqH00Qn","modeControl":"LhakYHML"};